(function () {

  function formatMoney(cents) {
    return new Intl.NumberFormat('en-CA', {
      style: 'currency',
      currency: 'CAD'
    }).format(cents / 100);
  }

  function getSelectedVariantId() {

    // Try variant ID from URL first
    const url = new URL(window.location.href);
    const urlVariant = url.searchParams.get('variant');

    if (urlVariant) {
      return Number(urlVariant);
    }

    // Fallback to product form
    const forms = document.querySelectorAll(
      'form[action*="/cart/add"]'
    );

    for (const form of forms) {

      const variantInput = form.querySelector(
        'input[name="id"], select[name="id"]'
      );

      if (variantInput && variantInput.value) {
        return Number(variantInput.value);
      }
    }

    return null;
  }

  function updateTariff() {

    const selectedVariantId =
      getSelectedVariantId();

    if (!selectedVariantId) return;

    document
      .querySelectorAll('[data-bb-tariff]')
      .forEach(function (tariffBox) {

        const productId =
          tariffBox.dataset.productId;

        const variantDataElement =
          document.querySelector(
            '[data-bb-tariff-variants][data-product-id="' +
            productId +
            '"]'
          );

        if (!variantDataElement) return;

        let variants;

        try {

          variants =
            JSON.parse(
              variantDataElement.textContent
            );

        } catch (error) {

          console.error(
            'BodyBest tariff JSON error:',
            error
          );

          return;
        }

        const variant =
          variants.find(function (item) {

            return (
              Number(item.id) ===
              Number(selectedVariantId)
            );

          });

        if (!variant) {

          tariffBox.style.display = 'none';
          return;

        }

        const inventory =
          Number(variant.inventory);

        // Main rule:
        // show tariff when inventory is 0 or negative
        const needsTariff =
          inventory <= 0;

        if (!needsTariff) {

          tariffBox.style.display = 'none';
          return;

        }

        // Calculate 25%
        const tariffAmount =
          Math.round(
            Number(variant.price) * 0.25
          );

        const priceElement =
          tariffBox.querySelector(
            '[data-bb-tariff-price]'
          );

        if (priceElement) {

          priceElement.textContent =
            formatMoney(tariffAmount);

        }

        tariffBox.style.display = 'block';

      });
  }

  function initTariff() {

    updateTariff();

    // Dropdown / radio changes
    document.addEventListener(
      'change',
      function () {

        setTimeout(updateTariff, 100);
        setTimeout(updateTariff, 300);

      }
    );

    // Empire swatches
    document.addEventListener(
      'click',
      function (event) {

        if (
          event.target.closest(
            'input, label, select, [data-variant-option], [data-option-value]'
          )
        ) {

          setTimeout(updateTariff, 100);
          setTimeout(updateTariff, 300);
          setTimeout(updateTariff, 500);

        }

      }
    );

    // Watch URL changes when Empire changes variants
    let previousUrl =
      window.location.href;

    setInterval(function () {

      if (
        window.location.href !==
        previousUrl
      ) {

        previousUrl =
          window.location.href;

        updateTariff();

      }

    }, 250);

  }

  if (
    document.readyState === 'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initTariff
    );

  } else {

    initTariff();

  }

})();